
import { isMobileOnly, osVersion } from "react-device-detect"

export const isDesktop = typeof window !== "undefined" && !isMobileOnly && osVersion!=="armv7l"
//export const isDesktop = typeof window !== "undefined" && window.innerWidth > 768


export const getPath = (url, pathPrefix) => {

  // absolute link
  if (url.indexOf("http") > -1 || url.indexOf("https") > -1) return url

  // relative link
  return `${pathPrefix}/${url}`

}


// TODO: TECHNOLOGIC DEBIT TO BE REMOVED
export const getBlockDescriptionProps = ({item, index, pathPrefix}) => {

  const { images, cta, modal, videos } = item

  return {
    ...item,
    inverted: index % 2 ? true : false,
    videos: videos?.filter(e => e.src && e.src.trim()),
    images: images?.filter(e => e.src && e.src.trim())?.map(image => ({...image, src: getPath(image.src, pathPrefix)})),
    cta,
    modal: (modal?.title?.trim().length || modal?.text?.trim().length || modal?.images?.filter(e => e.src && e.src.trim()))
      ? {
        ...modal,
        images: modal.images?.filter(e => e.src && e.src.trim())?.map(image => ({...image, src: getPath(image.src, pathPrefix)}))
      }
      : null
  }
}

export const getCardProps = ({item, pathPrefix}) => {

  const { images, cta, modal, videos } = item

  return {
    ...item,
    videos: videos?.filter(e => e.src && e.src.trim()),
    image: images?.filter(e => e.src && e.src.trim())?.map(image => ({...image, src: getPath(image.src, pathPrefix)}))?.[0],
    cta,
    modal: (modal?.title?.trim().length || modal?.text?.trim().length || modal?.images?.filter(e => e.src && e.src.trim()))
      ? {
        ...modal,
        images: modal.images?.filter(e => e.src && e.src.trim())?.map(image => ({...image, src: getPath(image.src, pathPrefix)}))
      }
      : null
  }
}